var _style, _rect, _path, _polygon, _path2, _polygon2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnlcLogoWithBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SNLC",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70.3 30.7",
    style: {
      enableBackground: "new 0 0 70.3 30.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#C41230;}\n\t.st2{fill:#231F20;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 70.3,
    height: 30.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.7,8.9l-2.4,1.2l2.4-4.9V8.9z M32.7,4.4l-3.2,6.5l3.2-1.6l3.2,1.6L32.7,4.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32.7,11 31,11.8 31,19.8 24.8,8.3 19.8,8.3 19.8,23.8 23.1,23.8 23.1,11.9 29.5,23.8 34.3,23.8  34.3,11.8 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.7,20.1c0.4,0.4,1.3,0.8,2.2,0.8c1.3,0,2.2-0.6,2.2-1.5c0-0.6-0.4-1.2-0.9-1.3l-2.8-0.8 c-2-0.5-3.1-2.4-3.1-4.4C6.3,10,8.7,8,11.5,8c1.8,0,3.3,0.8,4.2,1.8l-2.5,2.1c-0.3-0.3-1-0.6-1.7-0.6c-1.1,0-1.8,0.6-1.8,1.6 c0,0.6,0.4,1.2,0.9,1.3l2.8,0.8c2,0.5,3.1,2.5,3.1,4.4c0,2.9-2.6,4.8-5.5,4.8c-2.1,0-3.9-0.8-4.9-2L8.7,20.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "38.8,8.3 42.1,8.3 42.1,20.5 48.7,20.5 48.7,23.8 38.8,23.8 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61,12.2c-0.8-0.6-1.8-0.9-2.8-0.9c-2.6,0-4.8,2.2-4.8,4.8s2.1,4.8,4.8,4.8c1.2,0,2.3-0.4,3.2-1.2l2.8,1.9 c-1.5,1.6-3.6,2.6-5.9,2.6c-4.5,0-8.1-3.6-8.1-8.1S53.8,8,58.3,8c2.1,0,4,0.8,5.4,2.1L61,12.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnlcLogoWithBg);
export default __webpack_public_path__ + "static/media/SNLCLogoWithBG.4cda973ff6a917e111a32cca49a1e5dd.svg";
export { ForwardRef as ReactComponent };